import { action, observable } from 'mobx';
import apiCaller from '../../utils/api-caller';

class CmsTransportationTypeStore {
  @observable data = [];
  @observable transportationTypeOptions = [];
  @observable transportationType = null;

  @action getData() {
    return apiCaller.CmsTransportationTypes.get().then(resp => {
      if (!resp.isError) {
        if (resp.data) {
          this.data = resp.data;
        }
      }
    })
  }

  @action getOptions() {
    const languageCode = window.localStorage.getItem('lang') || 'en';
    return apiCaller.CmsTransportationTypes.getByLanguageCode(languageCode).then(resp => {
      if (resp) {
        if (resp.length > 0) {
          let options = [];
          resp.map(item => {
            options.push({
              label: item.name,
              value: item.name
            });
            return item;
          });

          this.transportationTypeOptions = options;
          this.transportationType = options[0].value;
        } else {
          this.transportationTypeOptions = [];
          this.transportationType = null;
        }
      } else {
        this.transportationTypeOptions = [];
        this.transportationType = null;
      }
    })
  }

  @action initCreate(activeLanguages) {
    const getDataByIdZero = this.data.find(fi => fi.id === 0);
    if (!getDataByIdZero) {
      let newData = {
        'id': 0,
        'sort': 0,
        'transportationTypeLanguages': []
      };

      activeLanguages.map(lang => {
        newData.transportationTypeLanguages.push({
          'id': 0,
          'transportationTypeId': 0,
          'languageId': lang.id,
          'name': ''
        });

        return lang;
      });

      this.data.push(newData);
    }
  }

  @action create() {
    const request = this.data.find(fi => fi.id === 0);
    return apiCaller.CmsTransportationTypes.create(request);
  }

  @action update(id) {
    const request = this.data.find(fi => fi.id === id);
    return apiCaller.CmsTransportationTypes.update(id, request);
  }

  @action delete(id) {
    return apiCaller.CmsTransportationTypes.delete(id);
  }

  @action cancel() {
    this.getData();
  }

  @action setsort(id, value) {
    let item = this.data.find(fi => fi.id === id);
    if (item) {
      item.sort = value;
    }
  }

  @action setname(id, langId, value) {
    let item = this.data.find(fi => fi.id === id);
    if (item) {
      let lang = item.transportationTypeLanguages.find(fi => fi.languageId === langId);
      if (lang) {
        lang.name = value;
      }
    }
  }

  @action settransportationType(value) {
    this.transportationType = value;
  }

  @action resetData() {
    this.transportationType = null;
    this.transportationTypeOptions = [];
  }
}

export default new CmsTransportationTypeStore();